// src/utils/buildFileTree.js
export function buildFileTree(files) {
    const root = { name: "/", children: {}, files: [] };
  
    files.forEach(file => {
      const parts = file.path.split("/");      // ["equipo1","subcarpeta","miarchivo.pdf"]
      let node = root;
  
      parts.forEach((part, i) => {
        const isFile = i === parts.length - 1;
        if (isFile) {
          node.files.push({ ...file, name: part });
        } else {
          node.children[part] = node.children[part] || { name: part, children: {}, files: [] };
          node = node.children[part];
        }
      });
    });
  
    return root;
  }
  